import { useMemo } from 'react';
import { ContactsHooks } from '@frontend/contacts';
import { useTranslation } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { createNavItem, createSubNavItems } from '../nav-item-utils';

export const useContactsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const tokens = useTranslationTokens();
  const hasListHomeIconAccess = ContactsHooks.useHasListHomeIconAccess();

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          label: tokens.allContacts,
          relativePath: '/all-contacts',
          trackingId: 'contact-2.0-list-menu-all',
          description: 'Displays the entire patient or client contact list, with searching and filtering capabilities.',
        },
        {
          label: t('Lists'),
          relativePath: '/lists',
          trackingId: 'contact-2.0-list-menu-lists',
          description: 'View collections lists, birthdays, and overdue patients, useful for targeted messaging.',
          show: hasListHomeIconAccess,
        },
      ]),
    [t, tokens.allContacts, hasListHomeIconAccess]
  );

  return useMemo(
    () =>
      createNavItem('contacts', {
        iconName: 'contacts',
        label: tokens.contacts,
        root: '/contacts',
        subNavItems,
      }),
    [tokens.contacts, subNavItems]
  );
};
